/* eslint-disable react-hooks/exhaustive-deps */
import ArrowBack from '@mui/icons-material/ArrowBackIos';
import RemoveIcon from '@mui/icons-material/RemoveCircleOutline';
import { Formik } from 'formik';
import { find, findIndex, get, isEmpty, isObject } from 'lodash';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { PhoneInput } from 'react-international-phone';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
// Services
import { DURATIONS } from '../../../helpers/constants';
import { convertJsonToFormData } from '../../../helpers/helper';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET, POST } from '../../../services/rest.service';
// Components
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useNavigate, useParams } from 'react-router';
import attachment from '../../../../assets/img/attachment.svg';
import { LOCAL_STORAGE_KEYS } from '../../../../global/const';
import Thumbnail from '../../../components/ThumbnailComponent';
import FormikPlaceSearch from '../../../components/UI/FormikPlaceSearch';
import TextInput from '../../../components/UI/TextInput';
import TextareaInput from '../../../components/UI/TextareaInput';
import PageLoader from '../../../components/loaders/PageLoader';
import NannyUpdateSchema from '../../../validationSchema/nannies/NannyUpdateSchema';

const NannyUpdate = () => {
  const [record, setRecord] = useState({});
  const [avatar] = useState(null);
  const [profilePicture, setProfilePicture] = useState({});
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [isOtherAvailable, setIsOtherAvailable] = useState(false);
  const [otherSkillDetails, setOtherSkillDetails] = useState({ title: '', document: {}, name: '' });
  const [selectedFile, setSelectedFile] = useState(null);
  const [educationalEntities, setEducationalEntities] = useState([]);
  const [experienceEntities, setExperienceEntities] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const skills = useSelector((state) => state.skills);
  const { id } = useParams();

  const handleNannySubmit = async (values) => {
    const payload = {
      ...values,
      profile_picture: profilePicture,
      skills: processSkills(),
      location: isObject(values.location) ? values.location : record.location,
      other_skills: [],
      reference: [],
      education: educationalEntities,
      experience: experienceEntities,
    };
    payload.other_skills = isOtherAvailable
      ? [
          {
            title: otherSkillDetails.title,
            document: otherSkillDetails.document,
          },
        ]
      : [];

    if (values.ref1name && values.ref1phone_number) {
      payload.reference.push({
        name: values.ref1name,
        phone_number: values.ref1phone_number,
        email: values.ref1email,
      });
      delete payload.ref1name;
      delete payload.ref1phone_number;
      delete payload.ref1email;
    }
    if (values.ref2name && values.ref2phone_number) {
      payload.reference.push({
        name: values.ref2name,
        phone_number: values.ref2phone_number,
        email: values.ref2email,
      });
      delete payload.ref2name;
      delete payload.ref2phone_number;
      delete payload.ref2email;
    }
    if (values.ref3name && values.ref3phone_number) {
      payload.reference.push({
        name: values.ref3name,
        phone_number: values.ref3phone_number,
        email: values.ref3email,
      });
      delete payload.ref3name;
      delete payload.ref3phone_number;
      delete payload.ref3email;
    }
    if (values.ref4name && values.ref4phone_number && values.ref4email) {
      payload.reference.push({
        name: values.ref4name,
        phone_number: values.ref4phone_number,
        email: values.ref4email,
      });
      delete payload.ref4name;
      delete payload.ref4phone_number;
      delete payload.ref4email;
    }
    if (values.ref5name && values.ref5phone_number && values.ref5email) {
      payload.reference.push({
        name: values.ref5name,
        phone_number: values.ref5phone_number,
        email: values.ref5email,
      });
      delete payload.ref5name;
      delete payload.ref5phone_number;
      delete payload.ref5email;
    }

    dispatch(showLoading('Please wait...'));
    try {
      await POST(`/admin/nanny/${record._id}/edit`, payload);
      toast.success('Account details updated!');
      navigate(-1);
      dispatch(hideLoading());
    } catch (err) {
      toast.error(err.message);
      dispatch(hideLoading());
    }
  };

  const processSkills = (skills) => {
    return selectedSkills.map((x, idx) => {
      return {
        skill_id: x.skill_id._id,
        document: x.document,
      };
    });
  };

  const getNanny = async () => {
    try {
      const { data } = await GET(`/admin/user/get_by_id/${id}`);
      const otherSkill = data.nanny?.other_skills;
      setRecord(data);
      setSelectedSkills(data.nanny.skills);
      setIsOtherAvailable(otherSkill.length > 0);
      setProfilePicture(data.nanny?.profile_picture);
      setOtherSkillDetails({
        title: otherSkill.length > 0 ? otherSkill[0].title : '',
        document: otherSkill.length > 0 ? otherSkill[0].document : '',
        name: otherSkill.length > 0 ? otherSkill[0].title : '',
      });
      setEducationalEntities(data.nanny.education);
      setExperienceEntities(data.nanny.experience);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getNanny();
  }, []);

  const handleSkillCheck = (e) => {
    const value = {
      skill_id: { _id: e.target.value, title: e.target.name },
      document: {},
    };
    const preValues = selectedSkills;
    if (e.target.checked) {
      setSelectedSkills([...preValues, value]);
    } else {
      let index = preValues.findIndex((x) => x.skill_id._id === e.target.value);
      setSelectedSkills([...preValues.slice(0, index), ...preValues.slice(index + 1)]);
    }
  };

  const removeDocument = (id) => {
    const preValues = selectedSkills;
    let skill = find(preValues, (x) => x.skill_id._id === id);
    const index = findIndex(preValues, (x) => x.skill_id._id === id);
    skill.document = {};
    skill.documentName = '';
    setSelectedSkills(Object.assign([], preValues, { [index]: skill }));
  };

  const handleOtherSkillCheck = (e) => {
    setIsOtherAvailable(!isOtherAvailable);
    setOtherSkillDetails({
      title: '',
      document: '',
    });
  };

  const handleProfilePicture = async (e) => {
    const file = e.target.files[0];

    const payload = {
      profile_picture: file,
    };

    const formData = convertJsonToFormData(payload);

    dispatch(showLoading('Updating Profile Picture...'));
    try {
      const res = await POST('/admin/nanny/upload-profile-photo', formData);
      dispatch(hideLoading());
      toast.success('Profile picture uploaded');
      setSelectedFile(file);
      setProfilePicture(res.data);
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };

  const handleFileChange = async (event) => {
    const id = event.target.name;
    const document = event.target.files[0];
    const preValues = selectedSkills;
    let skill = find(preValues, (x) => x.skill_id._id === id);
    const index = findIndex(preValues, (x) => x.skill_id._id === id);
    if (document.size < 10000000) {
      const payload = convertJsonToFormData({ skill_document: document });
      try {
        const res = await POST('/admin/user/nannyFileUpload', payload);
        skill.document = res.data.document;
        skill.documentName = document.name;
        setSelectedSkills(Object.assign([], preValues, { [index]: skill }));
      } catch (err) {
        toast.error(err.message);
      }
    } else {
      toast.error('This document is too large, please upload another. Maximum allowed size is 10MB');
    }
  };

  const handleOtherFileChange = async (e) => {
    const document = e.target.files[0];
    const payload = convertJsonToFormData({ skill_document: document });
    try {
      const res = await POST('/auth/user/nannyFileUpload', payload);
      setOtherSkillDetails({
        title: otherSkillDetails.title,
        document: res.data.document,
        name: document.name,
      });
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleOtherFileRemove = () => {
    setOtherSkillDetails({
      ...otherSkillDetails,
      document: undefined,
      name: '',
    });
  };

  const addEducationalEntity = (val) => {
    setEducationalEntities(educationalEntities.concat(val));
  };

  const removeEducationalEntity = (index) => {
    const entities = educationalEntities;
    setEducationalEntities([...entities.slice(0, index), ...entities.slice(index + 1)]);
  };

  const addExpEntity = (val) => {
    setExperienceEntities(experienceEntities.concat(val));
  };

  const removeExpEntity = (index) => {
    const entities = experienceEntities;
    setExperienceEntities([...entities.slice(0, index), ...entities.slice(index + 1)]);
  };

  const editorConfig = {
    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph',
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'ck-heading_heading1',
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2',
        },
      ],
    },
  };

  if (isEmpty(record)) {
    return <PageLoader />;
  }

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-lg-12 mb-5">
            <div className="card">
              <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">
                  <a href="#!" onClick={() => navigate(-1)}>
                    <ArrowBack />
                  </a>
                  Update Nanny
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="d-block text-center">
                      <label htmlFor="avatar">
                        <Thumbnail
                          file={selectedFile}
                          source={record.nanny?.profile_picture.url}
                          style={{
                            width: '150px',
                            height: '150px',
                            objectFit: 'cover',
                          }}
                          placeHolderImage={avatar}
                          className="rounded-circle mx-3 my-2 my-lg-0 img-fluid c-pointer"
                        />
                      </label>
                      <input id={'avatar'} type="file" className="d-none" onChange={handleProfilePicture} />
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <Formik
                      initialValues={{
                        first_name: record.first_name,
                        last_name: record.last_name,
                        email: record.email,
                        mobile_number: record.mobile_number,
                        note: get(record, 'nanny.note', ''),
                        location: isObject(record.location) ? record.location.address : record.location,
                        // skills: record.nanny.skills,
                        ref1name: get(record, 'nanny.reference[0].name', ''),
                        ref1phone_number: get(record, 'nanny.reference[0].phone_number', ''),
                        ref1email: get(record, 'nanny.reference[0].email', ''),
                        ref2name: get(record, 'nanny.reference[1].name', ''),
                        ref2phone_number: get(record, 'nanny.reference[1].phone_number', ''),
                        ref2email: get(record, 'nanny.reference[1].email', ''),
                        ref3name: get(record, 'nanny.reference[2].name', ''),
                        ref3phone_number: get(record, 'nanny.reference[2].phone_number', ''),
                        ref3email: get(record, 'nanny.reference[2].email', ''),
                        ref4name: get(record, 'nanny.reference[3].name', ''),
                        ref4phone_number: get(record, 'nanny.reference[3].phone_number', ''),
                        ref4email: get(record, 'nanny.reference[3].email', ''),
                        ref5name: get(record, 'nanny.reference[4].name', ''),
                        ref5phone_number: get(record, 'nanny.reference[4].phone_number', ''),
                        ref5email: get(record, 'nanny.reference[4].email', ''),
                        // social_security_number: get(record, 'nanny.social_security_number', ''),
                        about_nanny: get(record, 'nanny.about_nanny', ''),
                        how_soon_start: get(record, 'nanny.how_soon_start', ''),
                        date_of_birth: record.nanny && record.nanny.date_of_birth ? moment(record.nanny.date_of_birth).format('MM/DD/YYYY') : '',
                        gender: get(record, 'nanny.gender', 'Female'),
                        type: get(record, 'nanny.type', ''),
                        visa_status: get(record, 'nanny.visa_status', ''),
                        nanny_experience: get(record, 'nanny.nanny_experience', ''),
                        first_language: get(record, 'nanny.first_language', ''),
                        residential_address: get(record, 'nanny.residential_address', ''),
                        second_language: get(record, 'nanny.second_language', ''),
                        how_long_in_usa: get(record, 'nanny.how_long_in_usa', ''),
                        ethnicity: get(record, 'nanny.ethnicity', ''),
                        educational_entity: '',
                        experience_entity: '',
                        hourlyRate: get(record, 'nanny.hourlyRate', ''),
                        annualSalary: get(record, 'nanny.annualSalary', ''),
                      }}
                      onSubmit={(values) => {
                        handleNannySubmit(values);
                      }}
                      validationSchema={NannyUpdateSchema}
                    >
                      {(renderProps) => {
                        const { values, touched, errors, handleChange, handleBlur, setFieldValue, handleSubmit } = renderProps;

                        return (
                          <form
                            className="row"
                            onSubmit={handleSubmit}
                            // onKeyDown={(e) => {
                            //   if (e.key === 'Enter') e.preventDefault();
                            // }}
                          >
                            <TextInput
                              label={'First Name'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Please enter first name'}
                              size={'col col-lg-6'}
                              value={values.first_name}
                              error={touched.first_name && errors.first_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'first_name'}
                              id={'first_name'}
                            />
                            <TextInput
                              label={'Last Name'}
                              labelClasses={'text-uppercase'}
                              size={'col col-lg-6'}
                              placeholder={'Please enter last name'}
                              error={touched.last_name && errors.last_name}
                              value={values.last_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'last_name'}
                              id={'last_name'}
                            />
                            <TextInput
                              label={'Email'}
                              labelClasses={'text-uppercase'}
                              size={'col col-lg-6'}
                              placeholder={'Please enter email'}
                              type={'email'}
                              error={touched.email && errors.email}
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'email'}
                              id={'email'}
                            />

                            <div className={'form-group col col-lg-6'}>
                              <label className={'form-label text-uppercase'}>Mobile Number</label>
                              <PhoneInput defaultCountry="us" value={values.mobile_number} onChange={(e) => setFieldValue('mobile_number', e)} onBlur={handleBlur} />
                            </div>
                            <FormikPlaceSearch
                              id={'location'}
                              name={'location'}
                              label={'Location'}
                              labelClasses={'text-uppercase'}
                              size={'col col-lg-6'}
                              value={values.location}
                              onChange={(e) => {
                                const place = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.LOCATION));
                                setFieldValue('location', place);
                                setTimeout(() => {
                                  localStorage.removeItem(LOCAL_STORAGE_KEYS.LOCATION);
                                }, 100);
                              }}
                              placeholder={'Please enter location'}
                            />
                            <div className="form-group col-12 col-lg-6">
                              <label className="form-label text-uppercase" htmlFor="how_soon_start">
                                How Soon Start
                              </label>
                              <select id="how_soon_start" name="how_soon_start" className="form-control" value={values.how_soon_start} onChange={handleChange} onBlur={handleBlur}>
                                {DURATIONS.map((x, index) => {
                                  return (
                                    <option key={index} value={x}>
                                      {x}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <div className="form-group col-12 col-lg-6">
                              <label className="form-label text-uppercase w-100">Gender</label>
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  id="customRadioMale"
                                  type="radio"
                                  name="gender"
                                  checked={values.gender === 'Male'}
                                  value="Male"
                                  onChange={handleChange}
                                  className="custom-control-input"
                                />
                                <label htmlFor="customRadioMale" className="custom-control-label">
                                  Male
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  id="customRadioFemale"
                                  type="radio"
                                  name="gender"
                                  checked={values.gender === 'Female'}
                                  value="Female"
                                  onChange={handleChange}
                                  className="custom-control-input"
                                />
                                <label htmlFor="customRadioFemale" className="custom-control-label">
                                  Female
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  id="customRadioNonBinary"
                                  type="radio"
                                  name="gender"
                                  checked={values.gender === 'Non-Binary'}
                                  value="Non-Binary"
                                  onChange={handleChange}
                                  className="custom-control-input"
                                />
                                <label htmlFor="customRadioNonBinary" className="custom-control-label">
                                  Non-Binary
                                </label>
                              </div>
                            </div>
                            <div className="form-group col-12 col-lg-6">
                              <label className="form-label text-uppercase">Date of Birth</label>
                              <DatePicker
                                className={'form-control'}
                                placeholderText={'Date of Birth'}
                                showYearDropdown
                                value={values.date_of_birth}
                                onChange={(value) => setFieldValue('date_of_birth', moment(value).format('MM-DD-YYYY'))}
                              />
                              {touched.date_of_birth && errors.date_of_birth && <small className={'text-danger'}>{errors.date_of_birth}</small>}
                            </div>

                            <div className="form-group col-12 col-lg-6">
                              <label className="form-label text-uppercase w-100">Type</label>
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  id="nannyRadio"
                                  type="radio"
                                  name="type"
                                  checked={values.type === 'Nanny'}
                                  value="Nanny"
                                  onChange={handleChange}
                                  className="custom-control-input"
                                />
                                <label htmlFor="nannyRadio" className="custom-control-label">
                                  Nanny
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  id="sitterRadio"
                                  type="radio"
                                  name="type"
                                  checked={values.type === 'Sitter'}
                                  value="Sitter"
                                  onChange={handleChange}
                                  className="custom-control-input"
                                />
                                <label htmlFor="sitterRadio" className="custom-control-label">
                                  Sitter
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  id="bothRadio"
                                  type="radio"
                                  name="type"
                                  checked={values.type === 'Both'}
                                  value="Both"
                                  onChange={handleChange}
                                  className="custom-control-input"
                                />
                                <label htmlFor="bothRadio" className="custom-control-label">
                                  Both
                                </label>
                              </div>
                            </div>
                            <TextareaInput
                              label={'note'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Please enter note'}
                              size={'col-12'}
                              value={values.note}
                              error={touched.note && errors.note}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              rows={5}
                              name={'note'}
                              id={'note'}
                            />
                            <div className="form-group col-12">
                              <label className="form-label text-uppercase w-100">About Nanny</label>
                              <CKEditor
                                className="texteditor"
                                config={editorConfig}
                                editor={ClassicEditor}
                                data={values.about_nanny}
                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  setFieldValue('about_nanny', data);
                                }}
                              />
                            </div>
                            <TextareaInput
                              label={'Residential Address'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Residential address'}
                              size={'col-12'}
                              value={values.residential_address}
                              error={touched.residential_address && errors.residential_address}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              rows={5}
                              name={'residential_address'}
                              id={'residential_address'}
                            />

                            <div className="form-group col-12 my-4">
                              <hr />
                            </div>
                            <div className={'col-12'}>
                              <div className={'row'}>
                                <div className="form-group col-12 col-lg-6">
                                  <div className="form-group mb-0">
                                    <label className="form-label text-uppercase w-100">Educational Qualifications</label>
                                  </div>
                                  <div className="form-group">
                                    <div className={'d-flex'}>
                                      <TextInput
                                        label={null}
                                        labelClasses={'text-uppercase'}
                                        placeholder={'Qualification name eg. Nanny course'}
                                        size={'mb-0 mr-3 w-100'}
                                        value={values.educational_entity}
                                        error={touched.educational_entity && errors.educational_entity}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name={'educational_entity'}
                                        id={'educational_entity'}
                                      />
                                      <div>
                                        <button
                                          type="button"
                                          className={'btn btn-primary'}
                                          disabled={!values.educational_entity}
                                          onClick={() => {
                                            addEducationalEntity(values.educational_entity);
                                            setFieldValue('educational_entity', '');
                                          }}
                                        >
                                          Add
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={'w-100'}></div>
                                  <div className="form-group">
                                    <ul className="list-group list-group-flush">
                                      {educationalEntities.map((x, idx) => {
                                        return (
                                          <li className="list-group-item" key={idx}>
                                            {x}
                                            <a href="#!" className={'float-right c-pointer'} onClick={() => removeEducationalEntity(idx)}>
                                              <RemoveIcon />
                                            </a>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                </div>
                                <div className={'col-12 col-lg-6'}>
                                  <div className="form-group mb-0">
                                    <label className="form-label text-uppercase w-100">Experiences</label>
                                  </div>
                                  <div className="form-group">
                                    <div className={'d-flex'}>
                                      <TextInput
                                        label={null}
                                        labelClasses={'text-uppercase'}
                                        placeholder={'experience headline eg. Nanny in new york'}
                                        size={'mb-0 mr-3 w-100'}
                                        value={values.experience_entity}
                                        error={touched.experience_entity && errors.experience_entity}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name={'experience_entity'}
                                        id={'experience_entity'}
                                      />
                                      <div>
                                        <button
                                          type="button"
                                          className={'btn btn-primary'}
                                          disabled={!values.experience_entity}
                                          onClick={() => {
                                            addExpEntity(values.experience_entity);
                                            setFieldValue('experience_entity', '');
                                          }}
                                        >
                                          Add
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={'w-100'}></div>
                                  <div className="form-group">
                                    <ul className="list-group list-group-flush">
                                      {experienceEntities.map((x, idx) => {
                                        return (
                                          <li className="list-group-item" key={idx}>
                                            {x}
                                            <a href="#!" className={'float-right c-pointer'} onClick={() => removeExpEntity(idx)}>
                                              <RemoveIcon />
                                            </a>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="form-group col-12 my-4">
                              <hr />
                            </div>
                            <div className="form-group col-12 mb-0">
                              <label className="form-label text-uppercase w-100">skills</label>
                              {skills.map((x, index) => {
                                return (
                                  <div key={index} className="custom-control custom-checkbox custom-control-inline">
                                    <input
                                      id={x.title}
                                      name={x.title}
                                      value={x._id}
                                      type="checkbox"
                                      className="custom-control-input"
                                      onChange={handleSkillCheck}
                                      checked={selectedSkills.findIndex((skill) => skill.skill_id._id === x._id) > -1}
                                    />
                                    <label htmlFor={x.title} className="custom-control-label">
                                      {x.title}
                                    </label>
                                  </div>
                                );
                              })}
                              <div className="custom-control custom-checkbox custom-control-inline">
                                <input
                                  id={'other_skill'}
                                  name={'other_skill'}
                                  value={isOtherAvailable}
                                  checked={isOtherAvailable}
                                  type="checkbox"
                                  className="custom-control-input"
                                  onChange={handleOtherSkillCheck}
                                />
                                <label htmlFor={'other_skill'} className="custom-control-label">
                                  Other
                                </label>
                              </div>
                            </div>
                            <div className="form-group col-12 mb-0 mt-4">
                              <label className="form-label text-uppercase w-100">Qualifications</label>
                              {selectedSkills.map((x, index) => {
                                return (
                                  <div key={index} className="form-group form-group-btn">
                                    {x.skill_id.title && <label className="form-label">{x.skill_id.title}</label>}
                                    <div className="input-group append-left">
                                      <div className="input-group-append">
                                        <span className="input-group-text bg-transparent" id="basic-addon1">
                                          <img width="17" height="24" src={attachment} alt="attachment" />
                                        </span>
                                      </div>
                                      <input type="file" className="form-control d-none" id={x.skill_id._id} name={x.skill_id._id} onChange={handleFileChange} />
                                      <label htmlFor={x.skill_id._id} className="form-control">
                                        <span>{!isEmpty(x.document) && x.document.name ? 'Document Uploaded' : 'Upload your credential document'}</span>
                                      </label>
                                      {!isEmpty(x.document) && x.document.name && (
                                        <button type={'button'} className="btn btn-clear min-w-auto py-0 px-2" onClick={() => removeDocument(x.skill_id._id)}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 64 64">
                                            <path
                                              fill="#D80027"
                                              d="M28.941 31.786L.613 60.114c-.787.787-.787 2.062 0 2.849.393.394.909.59 1.424.59.516 0 1.031-.196 1.424-.59l28.541-28.541 28.541 28.541c.394.394.909.59 1.424.59.515 0 1.031-.196 1.424-.59.787-.787.787-2.062 0-2.849L35.064 31.786 63.41 3.438c.787-.787.787-2.062 0-2.849-.787-.786-2.062-.786-2.848 0L32.003 29.15 3.441.59C2.654-.196 1.38-.196.593.59c-.787.787-.787 2.062 0 2.849l28.348 28.347z"
                                            />
                                          </svg>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                            {isOtherAvailable && (
                              <Fragment>
                                <div className="col-12 col-md-5 form-group">
                                  <label className="form-label">Other Skill's Name</label>
                                  <input
                                    className="form-control"
                                    value={otherSkillDetails.title}
                                    onChange={(e) =>
                                      setOtherSkillDetails({
                                        title: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                                <div className="col-12 col-md-7">
                                  <div className="form-group form-group-btn">
                                    <label className="form-label">Other Skill's Document</label>
                                    <div className="input-group append-left">
                                      <div className="input-group-append">
                                        <button className="btn text-primary px-3" type="button">
                                          <img width="17" height="23" src={attachment} alt="attachment" />
                                        </button>
                                      </div>
                                      <input type="file" className="form-control d-none" name="other" id="otherSkill" onChange={handleOtherFileChange} />
                                      <label htmlFor="otherSkill" className="form-control">
                                        <span>{otherSkillDetails.document ? 'Document Uploaded' : 'Upload your credential document'}</span>
                                      </label>
                                      <button type="button" className="btn btn-clear min-w-auto py-0 px-2" onClick={handleOtherFileRemove}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 64 64">
                                          <path
                                            fill="#D80027"
                                            d="M28.941 31.786L.613 60.114c-.787.787-.787 2.062 0 2.849.393.394.909.59 1.424.59.516 0 1.031-.196 1.424-.59l28.541-28.541 28.541 28.541c.394.394.909.59 1.424.59.515 0 1.031-.196 1.424-.59.787-.787.787-2.062 0-2.849L35.064 31.786 63.41 3.438c.787-.787.787-2.062 0-2.849-.787-.786-2.062-.786-2.848 0L32.003 29.15 3.441.59C2.654-.196 1.38-.196.593.59c-.787.787-.787 2.062 0 2.849l28.348 28.347z"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </Fragment>
                            )}
                            <div className="form-group col-12 my-4">
                              <hr />
                            </div>
                            <div className="form-group col-12 mb-0">
                              <label className="form-label text-uppercase">reference</label>
                            </div>
                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Name'}
                              size={'col-12 col-lg-4'}
                              value={values.ref1name}
                              error={touched.ref1name && errors.ref1name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref1name'}
                              id={'ref1name'}
                            />

                            <div className={'form-group col-12 col-lg-4'}>
                              <PhoneInput
                                defaultCountry="us"
                                value={values.ref1phone_number}
                                onChange={(e, phone) => setFieldValue('ref1phone_number', phone.inputValue)}
                                onBlur={handleBlur}
                              />
                            </div>
                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Email'}
                              size={'col-12 col-lg-4'}
                              value={values.ref1email}
                              error={touched.ref1email && errors.ref1email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref1email'}
                              id={'ref1email'}
                            />

                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Name'}
                              size={'col-12 col-lg-4'}
                              value={values.ref2name}
                              error={touched.ref2name && errors.ref2name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref2name'}
                              id={'ref2name'}
                            />

                            <div className={'form-group col-12 col-lg-4'}>
                              <PhoneInput
                                defaultCountry="us"
                                value={values.ref2phone_number}
                                onChange={(e, phone) => setFieldValue('ref2phone_number', phone.inputValue)}
                                onBlur={handleBlur}
                              />
                            </div>
                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Email'}
                              size={'col-12 col-lg-4'}
                              value={values.ref2email}
                              error={touched.ref2email && errors.ref2email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref2email'}
                              id={'ref2email'}
                            />

                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Name'}
                              size={'col-12 col-lg-4'}
                              value={values.ref3name}
                              error={touched.ref3name && errors.ref3name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref3name'}
                              id={'ref3name'}
                            />

                            <div className={'form-group col-12 col-lg-4'}>
                              <PhoneInput
                                defaultCountry="us"
                                value={values.ref3phone_number}
                                onChange={(e, phone) => setFieldValue('ref3phone_number', phone.inputValue)}
                                onBlur={handleBlur}
                              />
                            </div>
                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Email'}
                              size={'col-12 col-lg-4'}
                              value={values.ref3email}
                              error={touched.ref3email && errors.ref3email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref3email'}
                              id={'ref3email'}
                            />

                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Name'}
                              size={'col-12 col-lg-4'}
                              value={values.ref4name}
                              error={touched.ref4name && errors.ref4name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref4name'}
                              id={'ref4name'}
                            />

                            <div className={'form-group col-12 col-lg-4'}>
                              <PhoneInput
                                defaultCountry="us"
                                value={values.ref4phone_number}
                                onChange={(e, phone) => setFieldValue('ref4phone_number', phone.inputValue)}
                                onBlur={handleBlur}
                              />
                            </div>
                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Email'}
                              size={'col-12 col-lg-4'}
                              value={values.ref4email}
                              error={touched.ref4email && errors.ref4email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref4email'}
                              id={'ref4email'}
                            />

                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Name'}
                              size={'col-12 col-lg-4'}
                              value={values.ref5name}
                              error={touched.ref5name && errors.ref5name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref5name'}
                              id={'ref5name'}
                            />
                            <div className={'form-group col-12 col-lg-4'}>
                              <PhoneInput
                                defaultCountry="us"
                                value={values.ref5phone_number}
                                onChange={(e, phone) => setFieldValue('ref5phone_number', phone.inputValue)}
                                onBlur={handleBlur}
                              />
                            </div>
                            <TextInput
                              label={''}
                              labelClasses={''}
                              placeholder={'Email'}
                              size={'col-12 col-lg-4'}
                              value={values.ref5email}
                              error={touched.ref5email && errors.ref5email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ref5email'}
                              id={'ref5email'}
                            />

                            {/* <div className="form-group col-12 my-4">
                              <hr />
                            </div>
                            <TextInput
                              label={'social security number'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Social Security Number'}
                              size={'col-12 col-lg-6'}
                              value={values.social_security_number}
                              error={touched.social_security_number && errors.social_security_number}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'social_security_number'}
                              id={'social_security_number'}
                            /> */}
                            <div className="form-group col-12 my-4">
                              <hr />
                            </div>
                            <TextInput
                              label={'How long in USA?'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Add number of years in USA'}
                              size={'col-12 col-lg-6'}
                              value={values.how_long_in_usa}
                              error={touched.how_long_in_usa && errors.how_long_in_usa}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'how_long_in_usa'}
                              id={'how_long_in_usa'}
                            />
                            <TextInput
                              label={'Visa Status'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Enter visa status'}
                              size={'col-12 col-lg-6'}
                              value={values.visa_status}
                              error={touched.visa_status && errors.visa_status}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'visa_status'}
                              id={'visa_status'}
                            />
                            <TextInput
                              label={"Nanny's Experience"}
                              labelClasses={'text-uppercase'}
                              placeholder={'Mention experience in years'}
                              size={'col-12 col-lg-6'}
                              value={values.nanny_experience}
                              error={touched.nanny_experience && errors.nanny_experience}
                              onChange={handleChange}
                              type={'number'}
                              onBlur={handleBlur}
                              name={'nanny_experience'}
                              id={'nanny_experience'}
                            />
                            <TextInput
                              label={'Hourly Rate'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Rate in ($)'}
                              size={'col-12 col-lg-6'}
                              value={values.hourlyRate}
                              error={touched.hourlyRate && errors.hourlyRate}
                              onChange={handleChange}
                              type={'text'}
                              onBlur={handleBlur}
                              name={'hourlyRate'}
                              id={'hourlyRate'}
                            />
                            <TextInput
                              label={"Nanny's Annual Salary"}
                              labelClasses={'text-uppercase'}
                              placeholder={'Salary in ($)'}
                              size={'col-12 col-lg-6'}
                              value={values.annualSalary}
                              error={touched.annualSalary && errors.annualSalary}
                              onChange={handleChange}
                              type={'text'}
                              onBlur={handleBlur}
                              name={'annualSalary'}
                              id={'annualSalary'}
                            />
                            <TextInput
                              label={'First Language'}
                              labelClasses={'text-uppercase'}
                              placeholder={'First language'}
                              size={'col-12 col-lg-6'}
                              value={values.first_language}
                              error={touched.first_language && errors.first_language}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'first_language'}
                              id={'first_language'}
                            />
                            <TextInput
                              label={'Second Language'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Second language'}
                              size={'col-12 col-lg-6'}
                              value={values.second_language}
                              error={touched.second_language && errors.second_language}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'second_language'}
                              id={'second_language'}
                            />
                            <TextInput
                              label={'Ethnicity'}
                              labelClasses={'text-uppercase'}
                              placeholder={'Mention ethnicity'}
                              size={'col-12 col-lg-6'}
                              value={values.ethnicity}
                              error={touched.ethnicity && errors.ethnicity}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name={'ethnicity'}
                              id={'ethnicity'}
                            />
                            <div className="form-group col-12">
                              <button type="button" onClick={() => navigate(-1)} className="btn btn-danger btn-lg">
                                Discard Changes
                              </button>
                              &nbsp;&nbsp;&nbsp;
                              <button type="submit" onClick={handleSubmit} className="btn btn-primary btn-lg">
                                Update
                              </button>
                            </div>
                          </form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NannyUpdate;
